import filterFieldsets from './helpers';
import { EXCLUDE_FIELDSETS_MAP } from './constants';

const FIELDSETS = [
  { type: 'email' },
  { type: 'personal-info', options: { gender: false } },
  { type: 'password' },
  { type: 'volunteer' },
  { type: 'terms-agreement' }
];

export default siteAbbr => ({
  pages: [
    {
      fieldsets: filterFieldsets(FIELDSETS, EXCLUDE_FIELDSETS_MAP, siteAbbr),
      sidebar: [{ type: 'contact' }, { type: 'signin' }]
    }
  ]
});
